<template>
    <div v-loading="$parentInfo.dialog_InvoiceDetail.loading" class="printOrder-data" >
        <vue-scroll :ops="$ops">
            <div class="noprint" v-show="$parentInfo.dialog_InvoiceDetail.printOn">
                <el-button icon="el-icon-printer" v-print="'#print'"
                           size="small">打印合同
                </el-button>
                <div style="position: absolute;right: 140px;top: -8px;z-index: 1;">
                    <canvas id="msg"></canvas>
                </div>
            </div>
            <div :style="{'height':$parentInfo.dialog_InvoiceDetail.maxHeight-45+'px'}" id="print">
                <div id="printArea"
                         class="printableArea"
                         v-if="$parentInfo.dialog_InvoiceDetail.showOn"
                         :class="{'ph':!$parentInfo.dialog_InvoiceDetail.printOn,'show':$parentInfo.dialog_InvoiceDetail.printOn}"
                         style=";position: relative;">

                            <div style="position: relative" class="invoice-body">
                                <div>
                                    <div class='invoiceNumber'>
                                        合同编号：{{$parentInfo.dialog_InvoiceDetail.leaseInvoiceDetail_val.prefix}}-{{$parentInfo.dialog_InvoiceDetail.leaseInvoiceDetail_val.id}}
                                    </div>
                                    <div >
                                        <h3 class="title">教学设备租赁合同</h3>

                                    </div>
                                    <div >
                                        <p><b>甲方（出借人）：上海墨帝教育科技服务有限公司</b></p>
                                        <p><b>乙方（租赁人）：<span style="text-decoration: underline">{{$parentInfo.dialog_InvoiceDetail.leaseInvoiceDetail_val.student_name}}</span>　　</b></p>
                                        <p><b>乙方监护人：<span style="text-decoration: underline">{{$parentInfo.dialog_InvoiceDetail.leaseInvoiceDetail_val.parent_name}}　 {{$parentInfo.dialog_InvoiceDetail.leaseInvoiceDetail_val.parent_identity}}</span></b></p>
                                        <p><b>乙方监护人身份证号：___________________</b></p>
                                    </div>
                                    <div>
                                        双方经协商，就乙方租赁甲方教学设备达成协议如下，以资共同遵守：
                                    </div>
                                    <div >
                                        <h3>一、设备信息</h3>
                                        <p>甲方同意将以下教学设备借给乙方使用：<br>
                                            设备名称：<br>
                                        </p>
                                        <p v-for="(invoiceShop,index) in $parentInfo.dialog_InvoiceDetail.leaseInvoiceDetail_val.invoiceShops" :key="index">
                                            □ {{invoiceShop.shop_name}}，数量：{{invoiceShop.amount}}，设备价值 {{invoiceShop.sum_price}} 元
                                        </p>
                                        <P>
                                            设备价值总计<span style="text-decoration: underline">{{$parentInfo.dialog_InvoiceDetail.leaseInvoiceDetail_val.hasPay}}</span>元。
                                            （以下简称设备）
                                        </P>
                                    </div>
                                    <div >
                                        <h3>二、费用及支付</h3>
                                        <p> 1.乙方需向甲方支付设备押金（大写）<span style="text-decoration: underline"> {{moneyToCapital}} </span> （<span style="text-decoration: underline"> {{$parentInfo.dialog_InvoiceDetail.leaseInvoiceDetail_val.hasPay|currency('￥')}} </span>）。<br>
                                            2.租赁期自<span style="text-decoration: underline"> {{$parentInfo.dialog_InvoiceDetail.leaseInvoiceDetail_val.start_date['year']}} </span>年<span style="text-decoration: underline"> {{$parentInfo.dialog_InvoiceDetail.leaseInvoiceDetail_val.start_date['month']}} </span>月<span style="text-decoration: underline"> {{$parentInfo.dialog_InvoiceDetail.leaseInvoiceDetail_val.start_date['day']}} </span>日起，乙方不得晚于<span style="text-decoration: underline"> {{$parentInfo.dialog_InvoiceDetail.leaseInvoiceDetail_val.end_date['year']}} </span>年<span style="text-decoration: underline"> {{$parentInfo.dialog_InvoiceDetail.leaseInvoiceDetail_val.end_date['month']}} </span>月<span style="text-decoration: underline"> {{$parentInfo.dialog_InvoiceDetail.leaseInvoiceDetail_val.end_date['day']}} </span>日归还，免租期<span style="text-decoration: underline"> {{$parentInfo.dialog_InvoiceDetail.leaseInvoiceDetail_val.free_day}} </span>天。日租金为<span style="text-decoration: underline"> {{$parentInfo.dialog_InvoiceDetail.leaseInvoiceDetail_val.daily_rent}} </span>元，归还时结算租金（含起租日及归还日），甲方优先从押金中扣除租金，押金剩余部分退还乙方。<br>
                                            3.甲方情况变化的，可提前5日通知乙方取消租赁，乙方应及时归还设备。<br>
                                            4.乙方到期未归还，或根据本合同预定提前终止租赁而不归还的，乙方应按每天设备价值的1%支付设备占用费。<br>
                                        </p>
                                    </div>
                                    <div >
                                        <h3>三、双方权利义务</h3>
                                        <p> 1.甲方保证借出的设备符合教学要求。<br>
                                            2.乙方接收设备时应对设备进行检查并确认设备质量状况良好，如有异议应在接收设备当时提出。<br>
                                            3.设备由乙方本人使用期间，未经甲方同意，不得买卖、抵押、质押、转租、转借租赁设备。乙方做好设备的保管，防止被盗、防止人为损坏。<br>
                                            4.乙方承担因不当使用或过失造成的租赁设备维修责任。。<br>
                                            5.如乙方在使用过程中，违反本合同规定的，甲方有权在任何时候收回设备，终止合同，并对乙方收取相应的赔偿费。<br>
                                            6.乙方归还设备时，应清除设备内账户信息及保证设备状况良好可正常使用。若造成损坏的，甲方有权收取相应维修赔偿款。<br>
                                            7.设备报废或无法归还，乙方应负赔偿责任时，应按本合同第一条约定的设备价值进行赔偿。<br>
                                            8.乙方逾期3日未归还设备的，甲方有权解除合同，且不退还乙方支付的所有押金。
                                        </p>

                                    </div>
                                    <div >
                                        <h3>四、争议解决</h3>
                                        <p>因本合同引起的或与本合同有关的任何争议，由合同各方协商解决，也可由有关部门调解。协商或调解不成的，应向本合同签订地有管辖权的人民法院起诉。</p>
                                    </div>
                                    <div >
                                        <h3>五、附则</h3>
                                        <p>1.	甲方收回设备且确认收回设备符合合同约定条件后，于二十个工作日内退还扣除本合同规定的费用之后的剩余押金。乙方也可选择将剩余押金可用于冲抵课程费用。具体以《教学设备租赁归还确认书》中约定为准。
                                        </p>
                                        <p>
                                            本合同一式两份，合同各方各执一份；本合同经各方签署后生效。
                                        </p>
                                    </div>

                                    <div>
                                        <p>签署地点：上海市青浦区</p>
                                        <p>签署日期： ________年________月________日</p>
                                    </div>
                                    <div style="float: left;width: 60%">
                                        <p>甲方签章：</p>
                                        <p>联系方式：</p>
                                    </div>
                                    <div style="float: left;">
                                        <p>乙方监护人签字：</p>
                                        <p>联系方式：</p>
                                    </div>

                                    <div style="clear: both"></div>
                                </div>
                            </div>
                            <div class="page-break" v-if="index==0"></div>

                    </div>
            </div>
        </vue-scroll>

    </div>
</template>
<style lang="scss">
    #msg{
        width:100px !important;
        height:100px !important;
    }
    .show {
        overflow: auto;
    }

    .ph {
        height: 100% !important;
    }

    .printableArea {
        padding: 10px 20px;
        color: #000 !important;
        font-weight: 500;
    }

    .printableArea .invoiceNumber{
        position:absolute;right:30px;font-size:10px;color:rgba(120, 130, 140, 0.74);
    }
    .printableArea .title{
        margin-top: 0;line-height: 30px;font-size: 18px;font-weight: 500;text-align: center;
    }
    .printableArea h3 {
        line-height: 30px;
        font-size: 15px;
        font-weight: 500;
    }

    .printableArea p {
        font-size: 12px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .printableArea table {
        font-size: 12px;
        border-color: #000;
    }

    .printableArea .table-bordered > tbody > tr > td, .printableArea .table-bordered > tbody > tr > th,
    .printableArea .table-bordered > tfoot > tr > td, .printableArea .table-bordered > tfoot > tr > th,
    .printableArea .table-bordered > thead > tr > td, .printableArea .table-bordered > thead > tr > th {
        border: 1px solid #000 !important;
        color: #000;
        font-size: 12px;
        font-weight: 500 !important;
    }

    .printableArea .table > tbody > tr > td, .printableArea .table > tbody > tr > th, .printableArea .table > tfoot > tr > td, .printableArea .table > tfoot > tr > th, .printableArea .table > thead > tr > td, .printableArea .table > thead > tr > th {
        padding: 7px 9px;
    }

    .printableArea .table-responsive {
        padding: 0 15px;
    }

    .printableArea .page-break{
        page-break-before: always  !important;
    }

    @media print{
        #print {
            .printableArea {
                padding: 0 !important;
                color: #000 !important;
                font-weight: 500;

            }

            .invoice-body{
                page-break-before:always;
            }

            .printableArea .title{
                margin-top: 0;
                line-height: 40px;
                font-size: 25px;
                font-weight: 500;
                text-align: center;

            }
            .printableArea .invoiceNumber{
                position:absolute;right:30px;font-size:15px;color:rgba(120, 130, 140, 0.74);
            }

            .printableArea h3 {
                line-height: 30px;
                font-size: 21px;
                font-weight: 500;
            }


            .printableArea p {
                font-size: 18px;
                padding-left: 15px;
                padding-right: 15px;
            }

            .printableArea table {
                font-size: 18px;
                border-color: #000;
            }

            .printableArea .table-bordered > tbody > tr > td, .printableArea .table-bordered > tbody > tr > th,
            .printableArea .table-bordered > tfoot > tr > td, .printableArea .table-bordered > tfoot > tr > th,
            .printableArea .table-bordered > thead > tr > td, .printableArea .table-bordered > thead > tr > th {
                border: 1px solid #000 !important;
                color: #000;
                font-size: 18px;
                font-weight: 500 !important;
            }

            .printableArea .table > tbody > tr > td, .printableArea .table > tbody > tr > th, .printableArea .table > tfoot > tr > td, .printableArea .table > tfoot > tr > th, .printableArea .table > thead > tr > td, .printableArea .table > thead > tr > th {
                padding: 7px 9px;
            }

            .printableArea .table-responsive {
                padding: 0 15px;
            }

            .printableArea .page-break{
                page-break-before: always  !important;
            }
        }
    }
</style>
<script>
    import QRCode from 'qrcode'
    export default {
        name: 'Dialog_InvoiceDetail',
        data() {
            return {
                QRCodeMsg:'234',
            };
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            moneyToCapital()
            {
                let n=this.$parentInfo.dialog_InvoiceDetail.leaseInvoiceDetail_val.hasPay
                if (n == 0) {
                    return "零";
                }
                if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n))
                    return "";
                var unit = "千百拾亿千百拾万千百拾元角分", str = "";
                n += "00";
                var p = n.indexOf('.');
                if (p >= 0)
                    n = n.substring(0, p) + n.substr(p + 1, 2);
                unit = unit.substr(unit.length - n.length);
                for (var i = 0; i < n.length; i++)
                    str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
                return str.replace(/零(千|百|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");

            },
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleInvoiceDetail()
            this.QRCodeMsg='http://server.modijiaoyu.com/invoicePhoto?invoice_id='+this.$store.state.modal.data.invoice_id
        },
        mounted(){
            var msg= document.getElementById('msg')
            // 将获取到的数据（val）画到msg（canvas）上
            QRCode.toCanvas(msg, this.QRCodeMsg, function (error) {
            })
        },
        methods: {
            handleInvoiceDetail() {
                this.$wApi.send(this.$parentInfo.path, 'leaseInvoiceDetail', {
                    'invoice_id': this.$store.state.modal.data.invoice_id,
                });
            },

            modelClose() {
                ipc.send('invoiceDetailClose');
            },

        }
    };
</script>
